import { render, staticRenderFns } from "./CommonTable.vue?vue&type=template&id=9f68a77e"
import script from "./CommonTable.vue?vue&type=script&lang=js"
export * from "./CommonTable.vue?vue&type=script&lang=js"
import style0 from "./CommonTable.vue?vue&type=style&index=0&id=9f68a77e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports